// @ts-check
import Icon from 'components/base/Icon';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import { LBButton } from '@linearb/buzz';

const SettingsButton = () => {
  const history = useHistory();

  const onClick = () =>
    history.replace(
      AppRouter.PROJECTS_PROJECT_PROGRESSION_INSIGHTS_CONFIG.path
    );

  return (
    <div className='ml-auto'>
      <LBButton size='icon' variant='ghost' onClick={onClick}>
        <Icon name='Settings' size='smaller' color='dodgerBlue' />
      </LBButton>
    </div>
  );
};

export default SettingsButton;
